import React, { FunctionComponent } from 'react'
import Svg, { G, Mask, Path } from 'react-native-svg'

type Props = {
  size?: number | string
}

export const ChildCaregiverTraining: FunctionComponent<Props> = ({ size = 124 }) => {
  return (
    <Svg width={size} height={size} viewBox='0 0 124 124' fill='none'>
      <Path
        d='M62.4359 0C53.8767 0 45.5724 1.47884 37.7532 4.39454C19.1377 11.3468 6.05028 26.7573 1.84543 46.6808C-0.933291 59.6694 -0.577986 71.6828 2.9383 83.39C7.42739 98.3413 18.4467 110.95 33.171 117.981C40.4805 121.479 48.8779 123.477 58.1256 123.916C59.3141 123.97 60.5221 124 61.7228 124C69.1425 124 76.6064 122.975 83.9085 120.956C84.4696 120.815 85.0038 120.67 85.5674 120.502C92.1295 118.566 98.0349 115.505 103.088 111.414C108.574 106.997 113.09 101.398 116.496 94.7813C117.167 93.4777 117.809 92.105 118.518 90.4633C122.414 81.3483 124.296 71.1446 123.962 60.9433C123.805 56.4328 123.139 51.6383 121.987 46.6808C120.091 38.6374 116.998 31.0728 113.043 24.7921C111.96 23.1059 110.966 21.6888 109.98 20.4148C102.872 11.1764 91.7962 4.69327 77.9614 1.67634C72.8794 0.565365 67.6552 0.00246884 62.4383 0.00246884L62.4359 0Z'
        fill='white'
      />
      <Mask id='mask0_6038_53912' maskUnits='userSpaceOnUse' x='5' y='5' width='114' height='114'>
        <Path
          d='M118.642 61.1119C118.49 56.789 117.834 52.3105 116.8 47.8592C115.109 40.6872 112.33 33.6164 108.52 27.5628C107.635 26.1902 106.729 24.8669 105.744 23.5954C98.5983 14.3126 87.7701 9.14775 76.687 6.73076C64.3421 4.03478 51.2154 4.82234 39.3482 9.24897C22.1785 15.6581 10.4902 29.6984 6.6774 47.758C5.21207 54.5991 4.78326 62.3315 5.43996 69.7603H5.3885C5.76831 73.982 6.52547 78.1025 7.66 81.8922C11.8771 95.9324 22.1246 107.074 35.1777 113.306C42.247 116.688 50.147 118.367 58.1769 118.749C66.3808 119.132 74.7121 118.088 82.4136 115.952C82.9184 115.826 83.3986 115.698 83.9034 115.545C89.9362 113.765 95.1874 111.017 99.6814 107.38C104.58 103.438 108.618 98.4778 111.749 92.3995C112.431 91.0762 113.036 89.7554 113.617 88.4049C117.302 79.7813 118.944 70.4219 118.615 61.1391L118.64 61.1144L118.642 61.1119Z'
          fill='white'
        />
      </Mask>
      <G mask='url(#mask0_6038_53912)'>
        <Path
          d='M61.8977 126.879C96.0483 126.879 123.733 98.9861 123.733 64.5781C123.733 30.1701 96.0483 2.27686 61.8977 2.27686C27.7471 2.27686 0.0625 30.1701 0.0625 64.5781C0.0625 98.9861 27.7471 126.879 61.8977 126.879Z'
          fill='#F5F2EE'
          stroke='#3BA5B5'
          stroke-width='0.353723'
          stroke-miterlimit='10'
        />
        <Path
          d='M30.2494 95.6896C27.8254 95.6896 25.8871 93.3564 26.0051 90.5693C26.3728 81.9992 24.716 65.6305 31.2208 59.4026C33.4087 57.31 38.3247 53.8783 40.8213 54.9132C49.6775 58.5855 52.6507 55.8983 56.1051 55.0267C59.4778 54.1733 64.3757 58.4857 66.1415 61.2001C70.127 67.3146 68.5972 82.7073 68.7062 90.7191C68.7425 93.4518 66.8315 95.6896 64.4574 95.6896H30.2494Z'
          fill='#FFC03C'
        />
        <Path
          d='M60.7099 40.9832C60.7099 47.2827 55.5061 52.9669 49.0893 52.9669C42.6725 52.9669 37.4688 47.2827 37.4688 40.9832C37.4688 34.6837 42.6725 28.9995 49.0893 28.9995C55.5061 28.9995 60.7099 34.6837 60.7099 40.9832Z'
          fill='#FFC03C'
        />
        <Path
          d='M66.83 95.8486C64.9053 95.8486 63.362 93.9966 63.4573 91.7769C63.7524 84.968 62.4314 71.9629 67.6017 67.0151C69.3402 65.3492 73.2486 62.6256 75.2322 63.4518C82.2681 66.3705 84.6331 64.2325 87.3748 63.5425C90.1165 62.8526 93.9477 66.2888 95.3503 68.445C98.5142 73.302 97.3022 85.5354 97.3885 91.8995C97.4203 94.0692 95.8996 95.8486 94.0158 95.8486H66.83Z'
          fill='#85CCD5'
        />
        <Path
          d='M90.4889 52.2391C90.4889 57.2012 86.2616 61.6808 81.0472 61.6808C75.8327 61.6808 71.6055 57.2012 71.6055 52.2391C71.6055 47.2769 75.8327 42.7974 81.0472 42.7974C86.2616 42.7974 90.4889 47.2769 90.4889 52.2391Z'
          fill='#85CCD5'
        />
      </G>
    </Svg>
  )
}
